/** Standard application colors; palette data is generated from these values. */
export const STANDARD_COLORS = {
  primary: '#2563eb',
  error: '#ef4444',
};
